import styled from 'styled-components';
import { useState } from 'react';
import type { DataPort } from '@glueapp/graph-types';
import { OutPort } from './Ports';
import { MorePorts } from '../graphComponents/MorePorts';
import { useNodeExecutionResult } from '@/GraphEditor/drawingLayer/contexts/NodeExecutionResultContext';
import { useIsNodePortConnected } from '@/GraphEditor/drawingLayer/contexts/NodeConnectedPortsContext';
import { DRAW_CONFIG } from '@/GraphEditor/drawingLayer/drawConfig.constant';

const List = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: right;
    margin-bottom: 8px;
`;

interface Props {
    ports: DataPort[];
}

export const OutPortList: React.FC<Props> = ({ ports }) => {
    const [shownOutPorts, setShownOutPorts] = useState<string[]>([]);
    const executionResult = useNodeExecutionResult();
    const isNodePortConnected = useIsNodePortConnected();

    if (ports.length <= 7) {
        return (
            <List>
                {ports.map((port, index) => (
                    <OutPort
                        key={index}
                        port={port}
                        // FIXME move to port itself as it will not be usable by itself otherwise
                        outputValue={executionResult?.output?.[port.name]}
                        executionDecision={executionResult?.executionDecisions?.[port.name]}
                    />
                ))}
            </List>
        );
    }

    const portsToDisplay = [];
    const notShownPorts = [];
    let i = 0;
    for (let port of ports) {
        if (i < DRAW_CONFIG.DEFAULT_MAX_DISPLAYED_OUTPORTS || shownOutPorts.includes(port.name) || isNodePortConnected(port.name)) {
            portsToDisplay.push(port);
        } else {
            notShownPorts.push(port);
        }
        i++;
    }

    return (
        <List>
            {portsToDisplay.map((port, index) => (
                <OutPort
                    key={index}
                    port={port}
                    outputValue={executionResult?.output?.[port.name]}
                    executionDecision={executionResult?.executionDecisions?.[port.name]}
                />
            ))}
            {notShownPorts.length > 0 ? (
                <MorePorts ports={notShownPorts} onPortClicked={port => setShownOutPorts(val => [...val, port.name])} />
            ) : null}
        </List>
    );
};
